import { env0Themes, type Env0Theme } from '@env0/ui-theme/env0';
import { showHiddenFeatures } from 'constants/config';
import { legacyThemes } from './themes.constants.legacy';

export const TOP_BAR_HEIGHT = '50px';
export const NAVBAR_WIDTH = '220px';
export const NAVBAR_COLLAPSED_WIDTH = '50px';
export const NAVBAR_TRANSITION_DURATION = '300ms';
export const BREADCRUMB_BAR_HEIGHT = '35px';

export type { Env0Theme };

// Some generated tokens still carry wrong values, so the legacy themes stay the default.
export const selectThemes = (useGeneratedTokens: boolean) => (useGeneratedTokens ? env0Themes : legacyThemes);

const themes = selectThemes(showHiddenFeatures());

export const darkTheme = themes.dark;

declare module '@emotion/react' {
  export interface Theme extends Env0Theme {}
}

export default themes.light;
